<template>
    <div>

    	<h1 class="mt-4">Fakturering för företagskunder</h1>

        <div class="content-container">

            <div class="row mb-4">

                <div class="col-24 col-md-4">
                    <select class="form-select new-list-group-field" v-model="settings.query.period" :disabled="settings.query.company_id" :class="{'disabled' :  settings.query.company_id}">
                        <option :value="period.date" :key="period.date" v-for="period in periods">{{ period.localized }}</option>
                    </select>
                </div>

                <div class="col-24 col-md-1 d-flex align-items-center">
                    <span>eller</span>
                </div>

                <div class="col-16 col-md-6">
                    <v-select
                        label="name"
                        placeholder="Välj företag"
                        :options="companies"
                        :reduce="company => company.id"
                        v-model="settings.query.company_id"
                    />
                </div>

                <div class="col-8 col-md-13 d-flex justify-content-end" @click="openExportModal()">
                    <button class="btn btn-primary btn-sm float-end">Spara Excel</button>
                </div>

            </div>

            <list ref="list" :settings="settings" :query.sync="settings.query" :useCookies="false">
                <div slot="item-row" slot-scope="props">
                    <div class="row g-3">
                        <div class="col-2" style="text-transform: capitalize;">
                            {{ props.item.month }} {{ props.item.year }}
                        </div>
                        <div class="col-4">
                            {{ props.item.company_name }}
                        </div>
                        <div class="col-5">
                            <span v-if="props.item.sum_monthly">Månadskostnad </span>
                            <span v-if="props.item.subscription.type === 'pay_per_treatment'">Månadens behandlingar </span>
                            <span v-if="props.item.start_fee" style="display: inline-block; margin-left: 4px;">
                                och startavgift
                            </span>
                            <span v-if="props.item.sum_monthly && props.item.sum_settlement">
                                 för {{ props.item.month }}.
                            </span>
                            <span v-if="props.item.sum_settlement">
                                Avräkning för {{ props.item.period_settlement.from_date }} - {{ props.item.period_settlement.to_date }}.
                            </span>
                        </div>
                        <div class="col-2">
                               <span v-if="props.item.start_fee">
                                {{ props.item.start_fee }} kr
                            </span>
                        </div>
                        <div class="col-3">
                             <span v-if="props.item.sum_monthly">
                                {{ props.item.sum_monthly }} kr
                            </span>
                        </div>
                        <div class="col-3">
                             <span v-if="props.item.num_settlement_treatments">
                                {{ props.item.num_settlement_treatments }} <span v-if="props.item.subscription.type !== 'pay_per_treatment'">extra</span> behandlingar
                            </span>
                            <span v-if="props.item.num_no_show_treatments">
                                {{ props.item.num_no_show_treatments }} sena avbokningar
                            </span>
                            <span v-if="props.item.subscription.type === 'pay_per_treatment'">
                                {{ props.item.num_total_treatments }} behandlingar
                            </span>
                        </div>
                        <div class="col-2">
                            <span>
                                {{ props.item.sum_total }} kr
                            </span>
                        </div>
                        <div class="col-3">
                            <span v-if="props.item.sum_settlement || props.item.sum_no_show ||  props.item.subscription.type === 'pay_per_treatment'">
                                <a target="_blank" :href="props.item.admin_url_pdf">
                                    <span class="fa fa-arrow-down" style="margin-right: 4px;"></span>
                                    Specifikation
                                </a>
                            </span>
                        </div>
                    </div>
                </div>
            </list>

        </div>

    </div>
    </template>

<script>
import vSelect from 'vue-select'

import Moment from 'moment'
import { extendMoment } from 'moment-range'

import lister from '../../../../shared/mixins/lister'
import fetcher from '../../../../shared/mixins/fetcher'

const moment = extendMoment(Moment)

export default {

    mixins: [
        lister,
        fetcher
    ],

    components: {
        vSelect
    },

    data () {
        return {
            companies: [],
            periods: [],

            fetcher: {
                autoFill: ['companies']
            },

            settings: {

                url: '/billing/list',
                query: {
                    period: moment().subtract(1, 'month').endOf('month').format('YYYY-MM-DD'),
                    company_id: null
                },

                columns: [
                    { column: 'id', name: 'Period', class: 'col-2', sortable: true, default: true },
                    { column: 'company', name: 'Företag', class: 'col-4', sortable: false },
                    { column: 'description', name: 'Beskrivning', class: 'col-5', sortable: false },
                    { column: 'start_fee', name: 'Startavg.', class: 'col-2', sortable: false },
                    { column: 'monthly_fee', name: 'Månadskostnad', class: 'col-3', sortable: false },
                    { column: 'extra', name: 'Extra', class: 'col-3', sortable: false },
                    { column: 'total', name: 'Totalt', class: 'col-2', sortable: false },
                    { column: 'pdf', name: 'Specifikation', class: 'col-3', sortable: false }
                ],

                export_fields: [
                    { column: 'year_month', name: 'Period' },
                    { column: 'company_name', name: 'Företag' },
                    { column: 'subscription.name', name: 'Abonnemang' },
                    { column: 'subscription.name_public', name: 'Publikt namn' },
                    { column: 'subscription.nice.name', name: 'Abonnemangstyp' },
                    { column: 'description', name: 'Beskrivning' },
                    { column: 'start_fee', name: 'Startavgift' },
                    { column: 'sum_monthly', name: 'Månadskostnad' },
                    { column: 'sum_treatments', name: 'Kostnad behandlingar' },
                    { column: 'sum_settlement', name: 'Extra' },
                    { column: 'sum_total', name: 'Totalt' },
                    { column: 'monthly_workplace_cost', name: 'Pris per arbetsplats/kalender' },
                    { column: 'num_workplaces', name: 'Antal arbetsplatser med kalender vid exportdatum' }
                ],

                bulk_actions: []

            }
        }
    },

    created () {
        const start = moment('2021-01-01', 'YYYY-MM-DD')
        const end = moment()
        const range = moment.range(start, end)

        for (const month of range.by('month')) {
            this.periods.push({
                localized: month.locale('sv').format('MMMM YYYY'),
                date: month.endOf('month').format('YYYY-MM-DD')
            })
        }
        this.periods.reverse()
    },

    computed: {
        fetcherUrl () {
            return '/billing/settings'
        }
    }
}
</script>
